import {
  DURASPEED_EXCLUSION_STEP_NAME,
  KIOSK_RELEASE_STEP_NAME,
  ROTATION_LOCK_SETTINGS,
  STAY_AWAKE_SETTING,
  WIFI_ON_STEP_NAME,
} from '@mxa-argos/modules/forja/constants/forja.constants';
import type { ForjaApk } from '@mxa-argos/modules/forja/interfaces/forja-apk.interface';
import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import { installStepName } from '@mxa-argos/modules/forja/lib/provisioning/steps/install.steps';
import { launchMOSStep } from '@mxa-argos/modules/forja/lib/provisioning/steps/launch-mos.step';
import {
  phaseASteps,
  settingsStep,
} from '@mxa-argos/modules/forja/lib/provisioning/steps/phase-a.steps';
import { phaseBSteps } from '@mxa-argos/modules/forja/lib/provisioning/steps/phase-b.steps';
import { postKioskSteps } from '@mxa-argos/modules/forja/lib/provisioning/steps/post-kiosk.steps';

export function finalCheckStepName(step: ForjaStep): string {
  return `check ${step.name}`;
}

// DuraSpeed is not checked: its state is only readable through the UI, which kiosk mode blocks by
// this point.
// Stay-awake, the rotation lock, the wifi activation and the kiosk release are not checked either:
// they are run scaffolding that the run itself reverts, and once in production the MDM policy may
// rewrite them.
const scaffoldingStepNames = new Set([
  KIOSK_RELEASE_STEP_NAME,
  WIFI_ON_STEP_NAME,
  ...[STAY_AWAKE_SETTING, ...ROTATION_LOCK_SETTINGS].map(
    (setting) => settingsStep(...setting).name,
  ),
]);

export function finalCheckSteps(apks: ForjaApk[]): ForjaStep[] {
  const kioskStep: ForjaStep = {
    name: 'kiosk engaged',
    verify: (device) => device.isKioskEngaged(),
    apply: async () => undefined,
    verifyTimeoutMs: 0,
  };

  const installedSteps: ForjaStep[] = apks.map((apk) => ({
    name: installStepName(apk),
    verify: (device) => device.isPackageInstalled(apk.release.packageName),
    apply: async () => undefined,
    verifyTimeoutMs: 0,
  }));

  return [
    ...phaseASteps().filter((step) => !scaffoldingStepNames.has(step.name)),
    ...installedSteps,
    ...phaseBSteps().filter((step) => step.name !== DURASPEED_EXCLUSION_STEP_NAME),
    launchMOSStep(),
    kioskStep,
    ...postKioskSteps(),
  ];
}
